import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  const userCards = document.querySelectorAll(".user-cards");

  userCards.forEach((block) => {
    const userCardWrappers = block.querySelectorAll(".user-card-wrapper");

    gsap.set(userCardWrappers, { opacity: 0, yPercent: 15 });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: block,
        start: "top 80%",
        end: "top 50%",
        toggleActions: "play none none none",
      },
    });

    userCardWrappers.forEach((wrapper, index) => {
      tl.to(
        wrapper,
        {
          opacity: 1,
          yPercent: 0,
          duration: 1,
          ease: "power2.out",
        },
        index * 0.2
      );
    });

    // Functionality only for mobile: add "active" class when each card comes into view
    // const isMobile = window.innerWidth < 1024;

    // if (isMobile) {
    //   userCardWrappers.forEach((wrapper) => {
    //     ScrollTrigger.create({
    //       trigger: wrapper,
    //       start: "top 60%",
    //       end: "bottom 40%",
    //       onEnter: () => wrapper.classList.add("active"),
    //       onLeave: () => wrapper.classList.remove("active"),
    //       onEnterBack: () => wrapper.classList.add("active"),
    //       onLeaveBack: () => wrapper.classList.remove("active"),
    //     });
    //   });
    // }
  });
});
